// The language code the lesson API expects.
//
// The app stores Armenian as "am" (its locale file is am.json), but the backend pins every
// lesson route to ^(en|hy|ru)$ — so "am" must be sent as "hy".
//
// Getting this consistent matters more than it looks. The server resolves lesson ORDER from
// course_lessons_meta BY LANGUAGE, and it fails closed when a course has no rows for the
// requested language. GET /lessons/meta supplies the `unlocked` flags the level map now trusts,
// while GET /lessons/{id}, /check and /complete_lesson are called with the learner's language.
// Fetching the map in "en" and then grading in "hy" resolves the two against different orderings:
// the map says lesson 1 is open, the content endpoint answers 403, and the learner sees "finish
// the previous lesson first" on the very first lesson of a course with no way to recover — the
// meta route is also the only thing that back-fills the missing rows from GCS, and it was never
// being asked in their language.
export const lessonLanguage = (activeLanguage) => {
  let language = activeLanguage;

  if (!language) {
    try {
      language = localStorage.getItem("language");
    } catch {
      // The app's UI default is Armenian, so the API must use Armenian too.
    }
  }

  const normalized = String(language || "am")
    .trim()
    .toLowerCase()
    .split("-")[0];

  if (normalized === "am" || normalized === "hy") return "hy";
  if (normalized === "ru") return "ru";
  return "en";
};

export default lessonLanguage;
